import net from "@ampeco/net";

const getChargePoint = async (identifier: string, connectorOrdering = 'desc'): Promise<any> => {
    return await net.get(`/app/displays/cs/${identifier}?connectorOrdering=${connectorOrdering}`);
}

export {
    getChargePoint
};
